import { makeRequest } from './https';
import { AddUser, UpdateUserData, User } from '../types/user.type';

const LIST_FRESH_MS = 20_000;
const listCache = new Map<string, { at: number; data: any }>();
const listInflight = new Map<string, Promise<any>>();

function invalidateUserListCache() {
  listCache.clear();
}


export const getCurrentUser = () => {
  return makeRequest({
    url: '/user/me',
    method: 'get',
  });
};

export const addUser = async (data: AddUser): Promise<User> => {
  const created = await makeRequest({
    url: '/user/register',
    method: 'post',
    data,
  });
  invalidateUserListCache();
  return created;
};

export const updateUserData = async (user_id: string, data: UpdateUserData) => {
  const updated = await makeRequest({
    url: `/user/${user_id}`,
    method: 'patch',
    data,
  });
  invalidateUserListCache();
  return updated;
};

export const getUsersList = (organization_id: string | null, limit?: number, offset?: number, search?: string) => {
  const params = {
    organization_id,
    ...(limit !== undefined ? { limit } : {}),
    ...(offset !== undefined ? { offset } : {}),
    ...(search ? { search } : {}),
  };
  const key = JSON.stringify(params);
  const cached = listCache.get(key);
  if (cached && Date.now() - cached.at < LIST_FRESH_MS) {
    return Promise.resolve(cached.data);
  }
  const pending = listInflight.get(key);
  if (pending) return pending;

  const request = makeRequest({
    url: '/user',
    method: 'get',
    params,
  }).then((data) => {
    listCache.set(key, { at: Date.now(), data });
    return data;
  }).finally(() => {
    listInflight.delete(key);
  });

  listInflight.set(key, request);
  return request;
};

export const deleteUserAccount = async (user_id: string) => {
  const deleted = await makeRequest({
    url: '/user/delete-account',
    method: 'post',
    data: { user_id },
  });
  invalidateUserListCache();
  return deleted;
}; 